export const DEFAULT_REQUEST_DEMO_CALENDLY_URL = 'https://calendly.com/longfloatit/30min';

export const DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL = 'https://calendly.com/longfloatit/demo-request-clone';